// Phase G3 Stage 1b: /play/coach — coach scaffolded hint.
import { createFileRoute } from "@tanstack/react-router";
import { CoachHint } from "@/screens/CoachHint";

export const Route = createFileRoute("/play/coach")({
  component: CoachHint,
});
